// Third Party
import * as React from 'react';

// Utils
import { routes } from '@routes';

// UI
import { Avatar } from '@components/avatar';
import { ExpandableText } from '@components/expandable-text';
import { Typography } from '@components/typography';

type Props = {
  accountSlug?: string;
  bio?: string;
  displayName?: string;
  imageUrl?: string;
};

export const InnkeeperBio: React.FC<Props> = ({
  accountSlug,
  bio,
  displayName,
  imageUrl,
}) => {
  if (imageUrl) {
    return (
      <div>
        <div className="flex flex-row items-center">
          <div className="relative aspect-1 h-20 overflow-hidden rounded-md shadow-md">
            <Avatar
              firstName={displayName}
              avatarUrl={imageUrl}
              shape="square"
              linkTo={routes.accounts(accountSlug || '')}
              data-testid={'@inkeeper/avatar'}
            />
          </div>
          <div className="pl-4">
            <Typography
              component="h2"
              variant="title4"
              data-testid={'@inkeeper/title'}
            >
              {displayName}
            </Typography>
          </div>
        </div>
        <div className="pt-4">
          {bio && (
            <ExpandableText
              text={bio}
              maxLines={6}
              maxLength={500}
              className="mt-2"
              typographyVariant="body1"
              testId="@inkeeper/description"
            />
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Typography
          component="h2"
          variant="title4"
          data-testid={'@inkeeper/tiltle'}
        >
          About The Property Manager
        </Typography>
        <Typography
          component="h5"
          variant="title5"
          data-testid={'@inkeeper/description'}
        >
          {displayName}
        </Typography>
        <div className="pt-4">
          <Typography
            component="p"
            variant="body1"
            data-testid={'@inkeeper/bio'}
          >
            {bio}
          </Typography>
        </div>
      </div>
    );
  }
};
